import createUseCase from "./SparePartsGalleryUseCase";
import createSparePartsComponent from "../../components/SparePartProducts/SparePartProducts";
import createSparePartsAnchor from "../MainBlock/SparePartsAnchor"

const init = (sparePartsServiceClient, templateContext) => {
  const sparePartsTargetContainer = document.querySelector("#pdp-spare-parts");
  const {productCode: parentProductCode} = templateContext;

  const sparePartsComponent = createSparePartsComponent(sparePartsTargetContainer);
  const sparePartsAnchor = createSparePartsAnchor();

  const useCase = createUseCase(sparePartsServiceClient, sparePartsAnchor, sparePartsComponent);
  useCase.handleInitialPageLoad(parentProductCode);
};

export default {init};
